import React, { useEffect } from "react";
import PropTypes from "prop-types";
import Checkboxes from "./Checkboxes";
import Time from "./Time";
import Location from "./Location";
import Register from "./Register";
import Cost from "./Cost";
import "../EventPage.css";
import { useDispatch, useSelector } from "react-redux";
import { loadTargetGroups } from "../../../redux/actions/targetGroupActions";
import { loadCategories } from "../../../redux/actions/categoryActions";
import { loadFoods } from "../../../redux/actions/foodActions"; 
import { loadFoodCost } from "../../../redux/actions/foodCostActions";


export default function EventForm({
  event,
  onSave,
  onDelete,
  onChange,
  onTargetgroupChange,
  setCustomTargetGroup,
  checkedTargetgroups,
  onCategoryChange,
  setCustomCategory,
  checkedCategories,
  onFoodChange,
  checkedFoods,
  setOccurrencesList,
  errors = {}
}) {
  const targetGroups = useSelector(state => state.targetGroups);
  const categories = useSelector(state => state.categories);
  const foods = useSelector(state => state.foods);
  const foodCost = useSelector(state => state.foodCost);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!targetGroups.length > 0) {
      getTargetGroupList();
    }
    if (!categories.length > 0) {
      getCategoryList();
    }
    if (!foods.length > 0) {
      getFoodList();
    }
    if (!foodCost.length > 0) {
      getFoodCostList();
    }
  }, []);

  const getTargetGroupList = async () => {
    await dispatch(loadTargetGroups());
  };

  const getCategoryList = async () => {
    await dispatch(loadCategories());
  };

  const getFoodList = async () => {
    await dispatch(loadFoods());
  };

  const getFoodCostList = async () => {
    await dispatch(loadFoodCost());
  };

  return (
    <form className="event-page" onSubmit={onSave}>
      <h2 className="name">{event.id ? "Redigera" : "Skapa"} händelse </h2>
      <div className="inputname">
        <span>*Namn</span>
          <input
            type="text"
            name="name"
            placeholder="namn"
            value={event.name}
            onChange={onChange}
          />
      </div>
      <Time
        startDate={event.startdate}
        startTime={event.starttime}
        endDate={event.enddate}
        endTime={event.endtime}
        onChange={onChange}
        setOccurrencesList={setOccurrencesList}
      />
      <Location
        className="location"
        label="Plats"
        address={event.address}
        city={event.city}
        onChange={onChange}
        error={errors.cost}
      />
      <div className="description-field">
        <span>Beskrivning</span>
        <textarea
          className="description"
          name="description"
          value={event.description ? event.description : ""}
          maxLength="1000"
          placeholder="Här kan man skriva en beskrivning om man vill"
          onChange={onChange}
        />
      </div>
      <div className="evlink">
        <span>Länk</span>
        <input
          name="link"
          type="url"
          defaultValue={event.link}
          placeholder="länk"
          onChange={onChange}
          maxLength="2000"
        />
      </div>
      <Checkboxes
        label="Målgrupp"
        className="targetgroup-input"
        items={targetGroups}
        onChange={onTargetgroupChange}
        checkedList={checkedTargetgroups}
        setCustomField={setCustomTargetGroup}
      />
      <Checkboxes
        label="Kategori"
        className="category-input"
        items={categories}
        onChange={onCategoryChange}
        checkedList={checkedCategories}
        setCustomField={setCustomCategory}
      />
      <Checkboxes
        label="Ätbart"
        className="food-input"
        items={foods}
        costItems={foodCost}
        onChange={onFoodChange}
        checkedList={checkedFoods}
      />
      <Register
        registration_needed={event.registration_needed === 1}
        registration_info={event.registration_info}
        onChange={onChange}
      />
      <Cost cost={event.cost} onChange={onChange} />

      <div className="line"></div>
      <button type="submit" className="save">
        Spara
      </button>
      <button type="submit" className="delete" onClick={onDelete}>
        Radera
      </button>
    </form>
  );
}

EventForm.propTypes = {
  event: PropTypes.object.isRequired,
  errors: PropTypes.object,
  onSave: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  checkedTargetgroups: PropTypes.array.isRequired,
  setCustomTargetGroup: PropTypes.func.isRequired,
  checkedCategories: PropTypes.array.isRequired,
  setCustomCategory: PropTypes.func.isRequired,
  checkedFoods: PropTypes.array.isRequired,
  onTargetgroupChange: PropTypes.func.isRequired,
  onCategoryChange: PropTypes.func.isRequired,
  onFoodChange: PropTypes.func.isRequired,
  setOccurrencesList: PropTypes.func.isRequired
};

/*
 <div>
      <form className="create-event" onSubmit={handleSubmit}>
        <span className="create-name">Namn:</span>
        <div className="create-name">
          <input
            type="text"
            value={name}
            maxLength="50"
            onChange={(e) => {
              setName(e.target.value);
            }}
          />
        </div>
        <Time
          starttime={starttime}
          endtime={endtime}
          occurrances={occurrances}
          setStarttime={setStarttime}
          setEndtime={setEndtime}
          setOccurrances={setOccurrances}
        />
        <Location
          address={address}
          setAddress={setAddress}
          city={city}
          setCity={setCity}
        />
        <div className="description">
          Beskrivning:
          <textarea
            className="textarea"
            value={description || ""}
            maxLength="1000"
            onChange={(e) => {
              setDescription(e.target.value);
            }}
          />
        </div>
        <input
          type="button"
          className="create-button"
          value={showDetails ? "Visa mindre" : "Visa mer"}
          onClick={handleShowDetails}
        />
        {showDetails && (
          <div className="details">
            <div className="link">
              <span>Länk:</span>{" "}
              <input
                type="url"
                value={link}
                maxLength="2000"
                onChange={(e) => {
                  setLink(e.target.value);
                }}
              />
            </div>
            <div className="checkboxes">
              <TargetGroups
                setCheckedTargetGroupBoxes={setCheckedTargetGroupBoxes}
                setCustomTargetGroup={setCustomTargetGroup}
              />
              <Categories
                setCheckedCategoryBoxes={setCheckedCategoryBoxes}
                setCustomCategory={setCustomCategory}
              />
            </div>
            <Food
              foodCost={foodCost}
              setFoodCost={setFoodCost}
              foods={foods}
              setFoods={setFoods}
            />
            <Register
              registration_needed={registration_needed}
              setRegistration_needed={setRegistration_needed}
              registration_info={registration_info}
              setRegistration_info={setRegistration_info}
            />
            <Cost cost={cost} setCost={setCost} />
          </div>
        )}
        {event ? (
          <div className="button-container">
            <input
              className="button"
              type="submit"
              onClick={handleDelete}
              value="Ta bort händelse"
            />
            <input className="button" type="submit" value="Spara" />
          </div>
        ) : (
          <input className="create-button" type="submit" value="Skapa" />
        )}
      </form>
    </div>
  );
}
*/
